import {Sizes} from "../../core/constants/sizes";
import {ValueOf} from "../../types/interfaces";

export const FlexSizes = Sizes
export type FlexSizesType = `${ValueOf<typeof FlexSizes>}`

export const FlexClass = {
	root: 'gov-flex',
}

